import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69023221"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "double" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wrapper_text_double" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text_double" }, "Данная буква уже была")
], -1))
const _hoisted_3 = [
  _hoisted_2
]

import {useStore} from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'WarningDouble',
  setup(__props) {

const store = useStore();


return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3, 512)), [
    [_vShow, _unref(store).getters.getNotificationDouble]
  ])
}
}

})